import { SET_VIDEO_PANEL_STATE, SET_VIDEO_INTERVAL } from "../actions/VideoToolsActions";
import { v4 as uuidv4 } from "uuid";

const initialState = {
  isOpenVideoPanel: false,
  deviceId: null,
  isOnlineVideo: true,
  dateStart: null,
  dateEnd: null,
  channels: 0,
  token: null,
  speedPlay: 2,
};

const videoToolsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VIDEO_PANEL_STATE: {
      return Object.assign({}, state, {
        isOpenVideoPanel: action.isOpenVideoPanel,
        deviceId: action.deviceId,
        isOnlineVideo: action.isOnlineVideo,
        dateStart: action.dateStart,
        dateEnd: action.dateEnd,
        channels: action.channels,
        speedPlay: action.speedPlay,
        token: uuidv4(),
      });
    }

    case SET_VIDEO_INTERVAL: {
      return Object.assign({}, state, {
        dateStart: action.dateStart,
        dateEnd: action.dateEnd,
        token: uuidv4(),
      });
    }

    default:
      return state;
  }
};

export default videoToolsReducer;
